export interface ChartTheme {
	tooltipBg: string;
	tooltipBorder: string;
	tooltipText: string;
	legendText: string;
	legendInactive: string;
	axisLabel: string;
	axisLabelSecondary: string;
	axisLine: string;
	splitLine: string;
}

const DARK_THEME: ChartTheme = {
	tooltipBg: "#18181b",
	tooltipBorder: "#3f3f46",
	tooltipText: "#fafafa",
	legendText: "#a1a1aa",
	legendInactive: "#52525b",
	axisLabel: "#71717a",
	axisLabelSecondary: "#a1a1aa",
	axisLine: "#3f3f46",
	splitLine: "#27272a",
};

const LIGHT_THEME: ChartTheme = {
	tooltipBg: "#ffffff",
	tooltipBorder: "#e4e4e7",
	tooltipText: "#18181b",
	legendText: "#52525b",
	legendInactive: "#d4d4d8",
	axisLabel: "#71717a",
	axisLabelSecondary: "#52525b",
	axisLine: "#d4d4d8",
	splitLine: "#e4e4e7",
};

export function getChartTheme(resolvedTheme: "light" | "dark"): ChartTheme {
	return resolvedTheme === "dark" ? DARK_THEME : LIGHT_THEME;
}
